<div class="d-flex justify-content-center pagination-wrapper">
  <div class="d-block d-md-flex">
    <!-- <div class="pagination-info text-right" *ngIf="pagination">
      {{ getInfo(pagination.page) }}
    </div> -->
    <ngb-pagination [page]="page" [pageSize]="pageSize" [collectionSize]="totalPages * pageSize" [directionLinks]="false" (pageChange)="pageChange.emit($event)" #pagination>
      <ng-template ngbPaginationPages let-page let-pages="pages">
        <li *ngIf="!pagination.previousDisabled()" class="page-item">
          <div *ngTemplateOutlet="anchor; context: { $implicit: { page: 1, text: '<<' } }"></div>
        </li>
        <li *ngIf="!pagination.previousDisabled()" class="page-item">
          <div *ngTemplateOutlet="anchor; context: { $implicit: { page: pagination.page - 1, text: '<' } }"></div>
        </li>
        <ng-container *ngFor="let p of pages">
          <li class="page-item" [class.active]="p === pagination.page" *ngIf="p >= pagination.page - window && p <= pagination.page + window">
            <div *ngTemplateOutlet="anchor; context: { $implicit: { page: p, text: p } }"></div>
          </li>
        </ng-container>
        <li *ngIf="!pagination.nextDisabled()" class="page-item">
          <div *ngTemplateOutlet="anchor; context: { $implicit: { page: pagination.page + 1, text: '>' } }"></div>
        </li>
        <li *ngIf="!pagination.nextDisabled()" class="page-item">
          <div *ngTemplateOutlet="anchor; context: { $implicit: { page: pagination.pageCount, text: '>>' } }"></div>
        </li>
      </ng-template>
    </ngb-pagination>
  </div>
</div>

<ng-template #anchor let-input>
  <a [routerLink]="link" [queryParams]="{ page: input.page }" [queryParamsHandling]="'merge'" *ngIf="link !== false">{{ input.text }}</a>
  <a href="javascript:;" (click)="pagination.selectPage(input.page)" *ngIf="link === false">{{ input.text }}</a>
</ng-template>
